import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/** En-tête + fond communs des pages publiques Carrières. */
export const CareersShell = ({ children, back = { to: "/", label: "Accueil" } }) => (
  <div className="min-h-screen bg-[#F8F9FA]">
    <header className="border-b border-[#DEE2E6] bg-white">
      <div className="max-w-[1200px] mx-auto px-6 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img src="/pag-logo.png" alt="PAG" className="h-9 w-9" />
          <span className="font-display font-black text-lg">PAG</span>
          <span className="text-xs uppercase tracking-[0.25em] text-[#868E96] border-l border-[#DEE2E6] pl-3">Carrières & partenaires</span>
        </Link>
        <Link to={back.to} className="text-sm font-semibold flex items-center gap-2 hover:text-[#002FA7]" data-testid="careers-back"><ArrowLeft className="h-4 w-4" />{back.label}</Link>
      </div>
    </header>
    <main className="max-w-[1200px] mx-auto px-6 py-10 lg:py-14">{children}</main>
    <footer className="border-t border-[#DEE2E6] bg-white">
      <div className="max-w-[1200px] mx-auto px-6 py-6 text-[11px] text-[#868E96] flex flex-wrap gap-x-4 gap-y-1">
        <span>© 2026 PAG — Parc Avenue Group</span>
        <Link to="/legal/confidentialite" className="hover:text-[#002FA7]">Politique de confidentialité</Link>
        <a href="mailto:contact@parcavenue.eu" className="hover:text-[#002FA7]">contact@parcavenue.eu</a>
      </div>
    </footer>
  </div>
);

export const KIND_STYLE = {
  emploi: { label: "Emploi", cls: "bg-[#002FA7] text-white" },
  business_partner: { label: "Business Partner", cls: "bg-[#FFD700] text-[#0A0A0A]" },
};

export const JobCard = ({ offer }) => {
  const k = KIND_STYLE[offer.kind] || KIND_STYLE.emploi;
  return (
    <Link to={`/carrieres/${offer.id}`} data-testid={`job-card-${offer.id}`}
          className="group block bg-white border border-[#DEE2E6] hover:border-[#002FA7] transition-colors p-6">
      <div className="flex items-start justify-between gap-3">
        <span className={`text-[9px] uppercase tracking-[0.25em] font-bold px-2 py-1 ${k.cls}`}>{k.label}</span>
        <span className="text-[10px] font-mono text-[#868E96]">{offer.reference}</span>
      </div>
      <h3 className="font-display font-black text-xl tracking-tight mt-4 group-hover:text-[#002FA7]">{offer.title}</h3>
      <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1 text-xs text-[#495057]">
        <span>{offer.contract_label}</span>
        {offer.location && <span>· {offer.location}</span>}
        {offer.remote_label && offer.remote !== "none" && <span>· {offer.remote_label}</span>}
        {offer.salary_label && <span className="font-semibold text-[#0A0A0A]">· {offer.salary_label}</span>}
      </div>
      {offer.skills?.length > 0 && (
        <div className="mt-4 flex flex-wrap gap-1.5">
          {offer.skills.slice(0, 6).map((s) => <span key={s} className="text-[10px] px-2 py-0.5 border border-[#DEE2E6] bg-[#F8F9FA]">{s}</span>)}
        </div>
      )}
      {offer.deadline && <div className="mt-4 text-[10px] uppercase tracking-wider text-[#868E96]">Candidatures jusqu'au {new Date(offer.deadline).toLocaleDateString("fr-FR")}</div>}
    </Link>
  );
};
